import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import LotScheduleTransfers from '~/components/lotScheduleTransfers/lotScheduleTransfers';

const LotTransfersCard = ({ lotTransfers, lot }) => {
  const inner = !lotTransfers.length ? (
    <Card className="pa3">
      <p>This lot has no transfers scheduled.</p>
    </Card>
  ) : (
    <Fragment>
      <LotScheduleTransfers transfers={lotTransfers} lot={lot} />
    </Fragment>
  );

  return (
    <div>
      <h3 className="f3 mt0">
        Scheduled transfers
        {lotTransfers.length && ` (${lotTransfers.length})`}
      </h3>
      {inner}
    </div>
  );
};

export default LotTransfersCard;



// WEBPACK FOOTER //
// ./src/components/lotTransfersCard/lotTransfersCard.jsx